<template>
  <div>
    <section id="news">
      <div v-if="blodRssObj.status === 'loaded'" class="content-wrapper">
        <h2><span>お知らせ</span></h2>
        <ul class="clearfix">
          <li
            v-for="(item, index) in blodRssObj.data.items.slice(0, 3)"
            :key="index"
          >
            <a :href="replaceUtmSource(item.url)">
              <p class="date">{{ formatDatetime(item.created) }}</p>
              <p class="article">{{ item.title }}</p>
              <img
                src="/static/renew_img/icon_arrow_pink.svg"
                alt="ニュース詳細"
              />
            </a>
          </li>
        </ul>
      </div>
      <div
        v-else-if="blodRssObj.status === 'loading'"
        class="blog-widghet-inner blog-loading"
      >
        お知らせブログを読み込み中です
      </div>
      <div v-else class="blog-widghet-inner error">
        <div v-if="blodRssObj.status === 'failed'">
          お知らせブログの読み込みに失敗しました
        </div>
        <div v-else-if="blodRssObj.status === 'offline'">
          オフラインのためお知らせブログを読み込めませんでした
        </div>
        <div v-else>お知らせブログで不明なエラーです</div>
        <el-button @click="loadRss">再読み込み</el-button>
      </div>
      <section id="howto" style="background: #fff">
        <div class="content-wrapper" style="background: #fff; padding: 0">
          <a
            class="btn_sub"
            href="https://blog.yagish.jp/archive"
            target="_blank"
            >もっと詳しくみる<img
              src="/static/renew_img/icon_link.svg"
              alt="お知らせをもっと見る"
          /></a>
        </div>
      </section>
      <div class="content-wrapper">
        <h2><span>メディア掲載</span></h2>
        <article>
          <img src="/static/renew_img/logo_media1.png" alt="Internet watch" />
          <img src="/static/renew_img/logo_media2.png" alt="Gigazine" />
          <img src="/static/renew_img/logo_media3.png" alt="HASHIGO" />
        </article>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'blogWidget',
  props: {
    jsonUrl: {
      type: String,
      required: true
    }
  },
  data: function () {
    return {
      blodRssObj: {
        error: null,
        data: null,
        status: null
      }
    }
  },
  methods: {
    replaceUtmSource: function (url) {
      if (url && String(url)) {
        return url.replace('utm_source=feed', 'utm_source=blogWidget')
      }
    },
    formatDatetime: function (datetime) {
      if (datetime) {
        return this.$formLib.dateFormat(new Date(datetime), 'yyyy/m/d')
      }
    },
    loadRss: function () {
      this.blodRssObj.data = null
      this.blodRssObj.error = null
      if (!this.$deviceLib.isOnline) {
        this.blodRssObj.status = 'offline'
        return
      }
      this.blodRssObj.status = 'loading'
      const app = this
      this.$axios
        .get(this.jsonUrl)
        .then(function (response) {
          app.blodRssObj.data = response.data
          app.blodRssObj.status = 'loaded'
        })
        .catch(function (error) {
          app.blodRssObj.error = error
          app.blodRssObj.status = 'failed'
          console.error(error)
        })
    }
  },
  mounted: function () {
    this.loadRss()
  }
}
</script>
